import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from '@portals/environments';

const AvatarShapes: Record<string, string> = {
	circle: 'circle',
	square: 'square',
	rectangle: 'rectangle',
	rounded: 'rounded',
	wide: 'wide',
};

@Component({
	selector: 'portals-avatar',
	templateUrl: './avatar.component.html',
	styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent implements OnChanges {
	@Input() imageUrl: string | null = '';
	@Input() centered = false;
	// Parse 1st character from a word, up to 2 characters
	@Input() _text: string = '';
	app = environment.app;
	set text(value: string) {
		const matches = value.match(/\b(\w)/g) || [];
		this._text = matches.slice(0, 2).join('');
	}
	get text() {
		return this._text;
	}

	// Parse avatar shape
	@Input() _shape: string = '';
	set shape(value: string) {
		this._shape = value;
	}
	get shape() {
		return `avatar--${AvatarShapes[this._shape]}`;
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes?.imageUrl.currentValue === 'assets/images/loading.gif') {
			setTimeout(() => {
				if (this.imageUrl === 'assets/images/loading.gif') {
					this.imageUrl = 'assets/images/video-thumb-small.png';
				}
			}, 14000);
		}
	}
}
